import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2919109647/src/apps/wrap.gifts/src/app/pricing/PricingPage.tsx");
